import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { CATEGORIES as STATIC_CATEGORIES } from "../mock/mockData";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CategoriesContext = createContext(null);

export const CategoriesProvider = ({ children }) => {
  const [categories, setCategories] = useState(STATIC_CATEGORIES);

  const reloadCategories = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/categories`);
      if (Array.isArray(res.data) && res.data.length) setCategories(res.data);
    } catch (e) {
      // keep static fallback on error
    }
  }, []);

  useEffect(() => { reloadCategories(); }, [reloadCategories]);

  const getCategory = useCallback(
    (slug) => categories.find((c) => c.slug === slug),
    [categories]
  );

  return (
    <CategoriesContext.Provider value={{ categories, getCategory, reloadCategories }}>
      {children}
    </CategoriesContext.Provider>
  );
};

export const useCategories = () => {
  const ctx = useContext(CategoriesContext);
  if (ctx) return ctx;
  return {
    categories: STATIC_CATEGORIES,
    getCategory: (slug) => STATIC_CATEGORIES.find((c) => c.slug === slug),
    reloadCategories: () => {},
  };
};
